import type { PropsWithChildren } from 'react';
import React from 'react';

import type { Icon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

export const Callout: React.FC<CalloutProps> = ({ icon, children, className, ...rest }) => {
	return (
		<div role="note" className={cn('bg-background-raised flex rounded-lg p-7', className)} {...rest}>
			{React.cloneElement(icon, {
				...icon.props,
				size: 'x-small',
				className: cn(
					icon.props.className,
					'bg-icon-information text-typography-inverse-strong mr-4 flex min-h-[32px] min-w-[32px] items-center justify-center rounded-full',
				),
			})}
			<div className="flex flex-col gap-2">{children}</div>
		</div>
	);
};

type CalloutProps = PropsWithChildren<{
	icon: React.ReactElement<Icon>;
}> &
	React.HTMLAttributes<HTMLDivElement>;
